import {
  AccountCircleOutlined,
  NotificationsNone,
  CenterFocusWeak,
  CreditCard,
} from "@material-ui/icons";

// 默认分页参数
export const DefaultPagination = {
  current: 1,
  pageSize: 10,
}

// 用于验证发送，固定参数
export const VerifyCode = "6666";

export const ContentType = {
  json: "application/json",
  form: "form",
};

// 导航
export const Navigation = {
  home: {
    name: "首页",
    value: "home",
    link: "/",
  },
  product: {
    name: "核心产品",
    value: "product",
    popup: true,
    list: [
      {
        name: "外综服平台",
        value: "product-service",
        link: "/product/service",
      },
      {
        name: "国际物流平台",
        value: "product-logistics",
        link: "/product/logistics",
      },
      {
        name: "大数据产品",
        value: "product-bigdata",
        list: [
          {
            name: "国内企业全景报告",
            value: "product-bigdata-depReport",
            link: "/product/bigdata/depReport",
          },
          // {
          //   name: "国外买家资信报告",
          //   value: "product-bigdata-fbcReport",
          //   link: "/product/bigdata/fbcReport",
          // },
          {
            name: "客户风控评分",
            value: "product-bigdata-cstRcScore",
            link: "/product/bigdata/cstRcScore",
          },
        ],
      },
    ]
  },
  cases: {
    name: "客户案例",
    value: "cases",
    link: "/cases",
  },
  about: {
    name: "关于我们",
    value: "about",
    link: "/about",
  },
  contact: {
    name: "联系我们",
    value: "contact",
    link: "/contact",
  },
};

// 登录
export const LoginNavigation = {
  login: {
    name: "登录",
    value: "login",
    icon: <AccountCircleOutlined className="text-black" />,
    link: "/login",
  }
}

// 登录、消息中心（已登录）
export const UserNavigation = {
  notifies: {
    name: "消息中心",
    value: "notifies",
    icon: <NotificationsNone />,
    link: "/notifies",
  },
  back: {
    name: "登录",
    value: "back",
    icon: <AccountCircleOutlined />,
    popup: true,
    list: [
      {
        name: "已购买业务",
        value: "back-purchased",
        link: "/back/purchased",
      },
      {
        name: "订单中心",
        value: "back-order",
        link: "/back/order",
      },
      {
        name: "发票管理",
        value: "back-invoice",
        link: "/back/invoice",
      },
      {
        name: "个人设置",
        value: "back-setting",
        link: "/back/setting",
      },
      {
        name: "退出登录",
        value: "back-logout",
        click: true,
      },
    ],
  },
};

// 首页商品类型
export const SoftwareType = {
  logistics: {
    label: "国际物流平台",
    value: "1",
    goods: {
      "1": {
        label: "SAAS版",
        value: "1",
        uniqueKey: "1",
        unit: "年",
        recommend: "1",
        detail: "#",
        platform: "#",
        content: {
          title: "国际物流平台",
          describe: "国际物流系统结合数十年的海运货代行业经验，为海运货运代理公司量身定制而成。",
          list: [
            "系统针对海运每个重要环节设置了强提醒功能，帮助客户减少疏漏，实时掌握所有业务进展情况。",
            "系统支持供应商价格实时管理功能，支持运价差异化展示；",
            "支持应收应付账款管理，同时支持拖车、报关、商检等各类海运业务场景管理。",
          ],
        },
      },
      "2": {
        label: "独立部署版",
        value: "2",
        uniqueKey: "2",
        unit: "年",
        recommend: "0",
        detail: "#",
        platform: "#",
        content: {
          title: "国际物流平台",
          describe: "国际物流系统结合数十年的海运货代行业经验，为海运货运代理公司量身定制而成。",
          list: [
            "系统针对海运每个重要环节设置了强提醒功能，帮助客户减少疏漏，实时掌握所有业务进展情况。",
            "系统支持供应商价格实时管理功能，支持运价差异化展示；",
            "支持应收应付账款管理，同时支持拖车、报关、商检等各类海运业务场景管理。",
          ],
        },

      },
    }
  },
  service: {
    label: "外综服务平台",
    value: "2",
    goods: {
      "1": {
        label: "基础版",
        value: "1",
        uniqueKey: "1",
        unit: "年",
        recommend: "0",
        detail: "#",
        platform: "#",
        content: {
          title: "外综服务平台",
          describe: "外综服系统符合国家税务总局2017年35号文件对外综服企业要求。",
          list: [
            "该系统能有效满足意向成为外综服企业的客户和需要系统化管理出口业务的外贸企业。",
            "外综服系统采用分布式架构，应对海量数据，部署在云服务器，高可用，松耦合，灵活扩展。系统可优化管理客户、货物报关资料、外汇、开票人等信息。",
            "系统扩展性能强，系统支持银企直连，无需登录网银结汇，直接可在系统查询到账信息并发起结汇请求。",
          ],
        },

      },
      "2": {
        label: "进阶版",
        value: "2",
        uniqueKey: "2",
        unit: "年",
        recommend: "1",
        detail: "#",
        platform: "#",
        content: {
          title: "外综服务平台",
          describe: "外综服系统符合国家税务总局2017年35号文件对外综服企业要求。",
          list: [
            "该系统能有效满足意向成为外综服企业的客户和需要系统化管理出口业务的外贸企业。",
            "外综服系统采用分布式架构，应对海量数据，部署在云服务器，高可用，松耦合，灵活扩展。系统可优化管理客户、货物报关资料、外汇、开票人等信息。",
            "系统扩展性能强，系统支持银企直连，无需登录网银结汇，直接可在系统查询到账信息并发起结汇请求。",
          ],
        },

      },
      "3": {
        label: "大数据版",
        value: "3",
        uniqueKey: "3",
        unit: "年",
        recommend: "1",
        detail: "#",
        platform: "#",
        content: {
          title: "外综服务平台",
          describe: "外综服系统符合国家税务总局2017年35号文件对外综服企业要求。",
          list: [
            "该系统能有效满足意向成为外综服企业的客户和需要系统化管理出口业务的外贸企业。",
            "外综服系统采用分布式架构，应对海量数据，部署在云服务器，高可用，松耦合，灵活扩展。系统可优化管理客户、货物报关资料、外汇、开票人等信息。",
            "系统扩展性能强，系统支持银企直连，无需登录网银结汇，直接可在系统查询到账信息并发起结汇请求。",
          ],
        },

      },
      "4": {
        label: "独立部署版",
        value: "4",
        uniqueKey: "4",
        unit: "年",
        recommend: "1",
        detail: "#",
        platform: "#",
        content: {
          title: "外综服务平台",
          describe: "外综服系统符合国家税务总局2017年35号文件对外综服企业要求。",
          list: [
            "该系统能有效满足意向成为外综服企业的客户和需要系统化管理出口业务的外贸企业。",
            "外综服系统采用分布式架构，应对海量数据，部署在云服务器，高可用，松耦合，灵活扩展。系统可优化管理客户、货物报关资料、外汇、开票人等信息。",
            "系统扩展性能强，系统支持银企直连，无需登录网银结汇，直接可在系统查询到账信息并发起结汇请求。",
          ],
        },

      },
    },
  },
  bigData: {
    label: "大数据平台",
    value: "3",
    goods: {
      "1": {
        label: "国外卖家资信报告",
        value: "1",
        uniqueKey: "1",
        unit: "份",
        recommend: "1",
        detail: "#",
        platform: "#",
        content: {
          title: "大数据平台",
          describe: "外综服系统符合国家税务总局2017年35号文件对外综服企业要求。",
          list: [
            "该系统能有效满足意向成为外综服企业的客户和需要系统化管理出口业务的外贸企业。",
            "外综服系统采用分布式架构，应对海量数据，部署在云服务器，高可用，松耦合，灵活扩展。系统可优化管理客户、货物报关资料、外汇、开票人等信息。",
            "系统扩展性能强，系统支持银企直连，无需登录网银结汇，直接可在系统查询到账信息并发起结汇请求。",
          ],
        },

      },
      "2": {
        label: "国内企业全景报告",
        value: "2",
        uniqueKey: "2",
        unit: "份",
        recommend: "0",
        detail: "#",
        platform: "#",
        content: {
          title: "大数据平台",
          describe: "提供基础企业信用信息，协助企业快速识别潜在合作风险",
          list: [
            // "该系统能有效满足意向成为外综服企业的客户和需要系统化管理出口业务的外贸企业。",
            // "外综服系统采用分布式架构，应对海量数据，部署在云服务器，高可用，松耦合，灵活扩展。系统可优化管理客户、货物报关资料、外汇、开票人等信息。",
            // "系统扩展性能强，系统支持银企直连，无需登录网银结汇，直接可在系统查询到账信息并发起结汇请求。",
          ],
        },

      },
      "3": {
        label: "国内企业全景报告",
        value: "3",
        uniqueKey: "3",
        unit: "份",
        recommend: "0",
        detail: "#",
        platform: "#",
        content: {
          title: "大数据平台",
          describe: "提供多维详尽的企业信用信息，参考信用报告可有效协助甄别企业的运营现状，进而促成优质企业合作，规避与不良信用企业合作造成的损失风险",
          list: [
            // "该系统能有效满足意向成为外综服企业的客户和需要系统化管理出口业务的外贸企业。",
            // "外综服系统采用分布式架构，应对海量数据，部署在云服务器，高可用，松耦合，灵活扩展。系统可优化管理客户、货物报关资料、外汇、开票人等信息。",
            // "系统扩展性能强，系统支持银企直连，无需登录网银结汇，直接可在系统查询到账信息并发起结汇请求。",
          ],
        },

      },
      "4": {
        label: "客户风控评分",
        value: "4",
        uniqueKey: "4",
        unit: "份",
        recommend: "0",
        detail: "#",
        platform: "#",
        content: {
          title: "大数据平台",
          describe: "通过大数据模型算法输出企业信用参考评分，直观呈现企业的信用评级",
          list: [
            // "该系统能有效满足意向成为外综服企业的客户和需要系统化管理出口业务的外贸企业。",
            // "外综服系统采用分布式架构，应对海量数据，部署在云服务器，高可用，松耦合，灵活扩展。系统可优化管理客户、货物报关资料、外汇、开票人等信息。",
            // "系统扩展性能强，系统支持银企直连，无需登录网银结汇，直接可在系统查询到账信息并发起结汇请求。",
          ],
        },

      },
    },
  },
};

// 首页产品预约类型
export const ProductType = [
  { label: "大数据平台", value: "1" },
  { label: "国际物流平台", value: "2" },
  { label: "外综服平台", value: "3" },
];

// 微信支付状态
export const PayType = {
  paying: "1",
  success: "2",
  fail: "3",
};

// 订单支付 tab
export const OrderPayTabs = [
  { label: "扫码支付", code: 0, icon: <CenterFocusWeak /> },
  { label: "银行支付", code: 1, icon: <CreditCard /> },
];

// 银行支付账号信息
export const BankCardInfo = [
  { name: "户名：", value: "广州市荣晶软件科技有限公司" },
  { name: "开户行：", value: "中国银行广州江南大道支行" },
  { name: "银行账号：", value: "708169296006" },
];

// 已购买业务 tab
export const PurchasedTabs = [
  { label: "已订购平台", code: 0 },
  { label: "已订购套餐包", code: 1 },
  { label: "已购买报告", code: 2 },
];

// 发票管理 tab
export const InvoiceTabs = [
  { label: "申请开票", code: 0 },
  { label: "开票中", code: 1 },
  { label: "已开票", code: 2 },
];

/** 版本对比-外综服平台-卡片背景色数组 */
export const BgcArrOutComSer = ["#0654D6", "#24C2D0", "#F4573A", "#F09000"]

/** 版本对比-国际物流平台-卡片背景色数组 */
export const BgcArrInterLogis = ["#0654D6", "#F09000"]

/** 版本对比-大数据产品-卡片背景色数组 */
export const BgcArrBigData = ["#0654D6", "#24C2D0", "#F4573A", "#F09000"]

// table columns currency default setting
export const ColumnsCurrencySetting = {
  locale: "CN",
  currencyCode: "CNY",
  minimumFractionDigits: 0,
};

export const ComponentType = {
  component: "component",
  input: "input",
  number: "number",
  select: "select",
  datetime: "datetime",
  dateRange: "dateRange",
  date: "date",
  time: "time",
};

// 消息通知状态
export const MsgReadType = {
  unRead: "0",
  read: "1",
};

/************************************ 枚举 start *********************************************/
// 订单支付状态
export const OrderPayType = {
  unpaid: "1",
  paying: "2",
  success: "3",
  fail: "4",
};
/** 订单状态枚举 */
export const OrderPayStatusEnum = {
  [OrderPayType.unpaid]: "未支付",
  [OrderPayType.paying]: "支付中",
  [OrderPayType.success]: "支付成功",
  [OrderPayType.fail]: "支付失败",
}

/** 订单产品类型枚举 */
export const OrderGoodsTypeEnum = {
  "1.2": "全景报告（基础）",
  "1.3": "全景报告（尊享版）",
  "1.4": "客户风控评分",
  "2.1": "物流-SASS",
  "2.2": "物流-独立部署",
  "3.1": "外综-基础",
  "3.2": "外综-基础",
  "3.3": "外综-数据",
  "3.4": "外综-独立",
}

/** 订单商品类型枚举 */
export const OrderShopTypeEnum = {
  "1": "大数据商品",
  "2": "国际物流平台",
  "3": "外贸综合服务平台",
}

/** 订单交付状态枚举 */
export const OrderDeliverStatusEnum = {
  "1": "未交付",
  "2": "已交付",
}

/** 报告商品类型枚举 */
export const ReportGoodsTypeEnum = {
  "1": "国外卖家资信",
  "2": "国内企业全景报告(基础版)",
  "3": "国内企业全景报告(尊享版)",
  "4": "客户风控评分",
}

/** 报告查询状态枚举 */
export const ReportSearchStatusEnum = {
  "0": "未执行",
  "1": "执行中",
  "2": "执行成功",
  "3": "执行失败",
}

/** 发票类型枚举 */
export const InvoiceStatusType = {
  apply: "1",
  success: "2",
  fail: "3",
}
export const InvoiceType = {
  eInvoice: "1",
}
export const InvoiceTypeEnum = {
  [InvoiceType.eInvoice]: "电子发票",
}

/** 发票抬头类型枚举 */
export const InvoiceHeadType = {
  personal: "1",
  company: "2",
}
export const InvoiceHeadTypeEnum = {
  [InvoiceHeadType.personal]: "个人",
  [InvoiceHeadType.company]: "单位",
}
/************************************ 枚举 end *********************************************/

/************************************ 文件module start *********************************************/
// 发票下载
export const InvoiceModel = "invoice";
/************************************ 文件module end   *******************************************/
